import { FC } from 'react'
import { cn } from '@wellesley/ui'

export type InfoItemProps = {
  counter: number
  title: string
  description: string
  className?: string
}

export const InfoItem: FC<InfoItemProps> = ({
  className,
  counter,
  title,
  description,
}) => (
  <div
    className={cn('flex flex-row gap-xxs text-base  text-gray-900', className)}
  >
    <div className="font-semibold">{counter}. </div>
    <div className="flex flex-col gap-1 ">
      <h5 className="font-semibold">{title}</h5>
      <p className="mt-xxs font-normal">{description}</p>
    </div>
  </div>
)
